import { createSelector } from '@reduxjs/toolkit';
const currentProduct = (state) => state.product.current;
const filterAttributes = (product, attributeType) => {
    var _a;
    return (((_a = product === null || product === void 0 ? void 0 : product.attributes) === null || _a === void 0 ? void 0 : _a.find((attribute) => {
        return attribute.ID === attributeType;
    })) || null);
};
export const compositionAndCareTextSelector = createSelector([currentProduct], (product) => filterAttributes(product, 'compositionAndCare'));
export const characteristicsTextSelector = createSelector([currentProduct], (product) => filterAttributes(product, 'characteristics'));
export const stylistNoteTextSelector = createSelector([currentProduct], (product) => filterAttributes(product, 'stylistNote'));
